import Vue from 'vue';

Vue.component('historical-accreditation', require('./components/application/HistoricalAccreditation').default);

Vue.component('historical-table', require('./components/historical/Index').default);
Vue.component('historical-tabs', require('./components/historical/Tabs').default);
Vue.component('historical-accreditation', require('./components/historical/accreditation/Index').default);
Vue.component('historical-evaluation', require('./components/historical/evaluation/Index').default);
Vue.component('historical-testification', require('./components/historical/testification/Index').default);
Vue.component('historical-eval-test-modal', require('./components/historical/Modal').default);
Vue.component('historical-maintenances-plan', require('./components/historical/maintenancePlan/Index').default);

Vue.component('historical-acc-init-ext', require('./components/historical/tab1-historical/HistoricalAccInitExt').default);
Vue.component('historical-vigilance-renovation', require('./components/historical/tab2-historical/HistoricalVigilanceRenovation').default);
Vue.component('historical-data-init', require('./components/historical/tab3-historical/HistoricalDataInit').default);

Vue.component('audit-acc-init-ext', require('./components/audit/tab1-audit/AuditAccInitExt').default);
Vue.component('audit-vigilance-renovation', require('./components/audit/tab2-audit/AuditVigilanceRenovation').default);
Vue.component('audit-data-init', require('./components/audit/tab3-audit/AuditHistoricalInit').default);



Vue.component('audit-table', require('./components/audit/Index').default);
Vue.component('audit-tabs', require('./components/audit/Tabs').default);
Vue.component('audit-accreditation', require('./components/audit/accreditation/Index').default);
Vue.component('audit-evaluation', require('./components/audit/evaluation/Index').default);
Vue.component('audit-testification', require('./components/audit/testification/Index').default);
Vue.component('audit-eval-test-modal', require('./components/audit/Modal').default);

Vue.component('audit-historical-tabs', require('./components/tab/Index').default);


Vue.component('session-audit-index', require('./components/session-audit/Index').default);
Vue.component('session-audit-default-filter', require('./components/session-audit/default-filter').default);

Vue.component('th-audit-index', require('./components/session-audit/IndexTH').default);
Vue.component('th-audit-filter', require('./components/session-audit/th-filter').default);

/* Reportería */
Vue.component('reporting-index', require('./components/reporting/Index').default);
Vue.component('reporting-tabs', require('./components/reporting/accreditation-proccess/Index').default);

Vue.component('audit-file-table', require('./components/audit-file-log/Index').default);
Vue.component('audit-file-register', require('./components/audit-file-log/register/Index').default);
Vue.component('audit-file-modal', require('./components/audit-file-log/register/Modal').default);

//versionamiento de archivos
Vue.component('versions-file-index', require('./components/versions-file/Index').default);
Vue.component('versions-file-modal', require('./components/versions-file/Modal').default);
Vue.component('documents-type-modal', require('./components/versions-file/TypeModal').default);

//procesos con retrasos
Vue.component('process-delays-index', require('./components/process-delays/Index').default);
Vue.component('process-delays-inprogress', require('./components/process-delays/InProgress').default);
Vue.component('process-delays-finished', require('./components/process-delays/Finished').default);

